import { Component, Vue } from 'vue-property-decorator';
import MyTasks from './my-tasks/MyTasks.vue';
import MyLevel from './my-level/MyLevel.vue';
import LeaderBoard from './leader-board/LeaderBoard.vue';
import RisingStars from './rising-stars/RisingStars.vue';
import MyRecord from './my-hrm-record/MyRecord.vue';

@Component({
  components: {
    MyTasks,
    MyLevel,
    LeaderBoard,
    RisingStars,
    MyRecord
  }
})
export default class Home extends Vue {}
